import { Button } from '@fd/frontend/components/ui/Button';
import Flex from '@fd/frontend/components/ui/Flex';
import Footer from '@fd/frontend/components/ui/Footer';
import { useTotals } from '@fd/frontend/hooks/useTotals';
import { ChevronRight } from 'lucide-react';
import { NavLink } from 'react-router';

export default function ProxiesBuyFooter() {
  const totals = useTotals();

  if (!totals.totalPriceText) return null;
  return (
    <Footer className={totals.subtotalPrice == 0 ? 'hidden' : ''}>
      <Flex.Row gap="5" className="flex items-center justify-between">
        <span className="text-white font-semibold text-center">
          {totals.totalPriceText}
          <br />
          <span className="text-primary-background whitespace-nowrap font-normal">
            /month
          </span>
        </span>
        <NavLink to="/proxies/buy/summary" className="w-full">
          <Button className="w-full h-11 gap-2 text-sm">
            Proceed to checkout
            <ChevronRight className="w-4 h-4 group-hover:translate-x-1 transition-all" />
          </Button>
        </NavLink>
      </Flex.Row>
    </Footer>
  );
}
